// @flow

import PropTypes from 'prop-types';
import gql from 'graphql-tag';
import { graphql } from 'react-apollo';
import { HomeFragment } from '../../screens/Home/fragments';

type HomeQueryProps = {
  entity: PropTypes.any.isRequired,
  loading: PropTypes.boolean,
};

const query = gql`
  query HomePage($nid: String) {
    nodeById(id: $nid, language: en) {
      ...HomeFragment
    }
  }

  ${HomeFragment}
`;

const withQuery = graphql(query, {
  options: () => ({
    variables: {
      nid: 4,
    },
  }),
  props: ({ data: { nodeById, loading } }: any): HomeQueryProps => ({
    entity: nodeById,
    loading,
  }),
});

export default withQuery;



// WEBPACK FOOTER //
// ./screens/App/components/HomeQuery/index.js